// extracted by mini-css-extract-plugin
export default {"wrap":"WarningCard_wrap__eA7nI"};